export default __webpack_public_path__ + "static/media/cz.66f3c485.svg";